import { BigNumber } from '@0x/utils'
import { Asset } from 'app-lib/assetUtils'
import { ChainId } from 'bzx-common/src/config/appConfig'

export default class WithdrawCollateralEvent {
  public static readonly topic0: string =
    '0x7b1bab051266a4a36232da9b4341daf225fa42f7202b0e7207b9b502644ff1bb'
  public readonly chainId: ChainId
  public readonly user: string
  public readonly asset: Asset
  public readonly loanId: string
  public readonly amount: BigNumber
  public readonly blockNumber: BigNumber
  public readonly txHash: string
  public readonly timestamp: Date

  constructor(
    chainId: ChainId,
    user: string,
    asset: Asset,
    loanId: string,
    amount: BigNumber,
    blockNumber: BigNumber,
    txHash: string,
    timestamp: Date
  ) {
    this.chainId = chainId
    this.user = user
    this.asset = asset
    this.loanId = loanId
    this.amount = amount
    this.blockNumber = blockNumber
    this.txHash = txHash
    this.timestamp = timestamp
  }
}
